/**
 * S5c (RPT-1): the period the Ricavi report opens on, from Rome's today:
 * this month so far, by day. Whether a period is allowed is the server's
 * to say (422 report_range); the screen only proposes one.
 */
export function defaultRange(today: string): { from: string; to: string } {
  return { from: `${today.slice(0, 7)}-01`, to: today }
}
